export default {
  UPDATE_NAVIGATIONS_FILTERS: 'UPDATE_NAVIGATIONS_FILTERS '
}
